import React from "react";

import { EL_ID_PORTAL_MAIN_AFTER } from "@/shared/components/Portal/PortalMainAfter/constants";

import styles from "./PortalMainAfter.module.scss";

const PortalMainAfter = () => {
  return (
    <div className={styles["root"]} id={EL_ID_PORTAL_MAIN_AFTER} />
  );
};

export default PortalMainAfter;
